import { isSameDay } from "date-fns";
import { DATE_RANGE_PRESETS_BY_ID } from "@helpers/date";

interface DatePresetDates {
    startDate: Date | undefined;
    endDate: Date | undefined;
}

export type AccountingDatePresetSource =
    | { type: "allTime" }
    | { type: "urlDates"; presetId: string | undefined }
    | {
          type: "implicitDates";
          queryPreset: string | undefined;
          rememberedDatePeriod: { presetId: string | undefined } | undefined;
      };

interface ResolveAccountingDatePresetOptions extends DatePresetDates {
    source: AccountingDatePresetSource;
}

export function resolveKnownDatePreset({
    presetId,
    startDate,
    endDate,
}: DatePresetDates & {
    presetId: string | undefined;
}): string | undefined {
    if (!presetId || !startDate || !endDate) {
        return undefined;
    }
    const preset = DATE_RANGE_PRESETS_BY_ID[presetId];
    if (!preset) {
        return undefined;
    }
    const today = new Date();
    return isSameDay(preset.getStart(today), startDate) &&
        isSameDay(preset.getEnd(today), endDate)
        ? presetId
        : undefined;
}

export function resolveAccountingDatePreset({
    source,
    startDate,
    endDate,
}: ResolveAccountingDatePresetOptions): string | undefined {
    switch (source.type) {
        case "allTime":
            return undefined;
        case "urlDates":
            return resolveKnownDatePreset({
                presetId: source.presetId,
                startDate,
                endDate,
            });
        case "implicitDates": {
            const presetId =
                source.queryPreset ??
                source.rememberedDatePeriod?.presetId ??
                (source.rememberedDatePeriod ? undefined : "this_year_to_date");
            return resolveKnownDatePreset({
                presetId,
                startDate,
                endDate,
            });
        }
    }
}
